export default __webpack_public_path__ + "static/media/kitchen5-afterC.b555b709.jpg";